import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from '@repo/ui';
import {
  authApi,
  SocialLoginUrlResponse,
  SocialLoginParams,
  OAuthCallbackParams,
  OAuthCallbackResponse
} from '@xtnd/web/features/auth/api';

// Hook for getting social login URL
export function useSocialLogin() {
  return useMutation({
    mutationFn: async (params: SocialLoginParams): Promise<SocialLoginUrlResponse> => {
      return authApi.getSocialLoginUrl(params);
    },
    onSuccess: (data) => {
      // Redirect to OAuth provider
      window.location.href = data.loginUrl;
    },
    onError: (error) => {
      console.error('Failed to get social login URL:', error);
      showToast.error('Failed to initiate social login. Please try again.');
    },
  });
}

// Hook for handling OAuth callback
export function useOAuthCallback() {
  return useMutation({
    mutationFn: async (params: OAuthCallbackParams): Promise<OAuthCallbackResponse> => {
      return authApi.handleOAuthCallback(params);
    },
    // onSuccess: () => {
    //   showToast.success('Login successful!');
    // },
    onError: (error) => {
      console.error('OAuth callback failed:', error);
      showToast.error('Authentication failed. Please try again.');
    },
  });
}

// Hook for handling Microsoft OAuth callback (token already stored)
export function useMicrosoftCallback() {
  return useMutation({
    mutationFn: async (): Promise<{ success: boolean }> => {
      return authApi.handleMicrosoftCallback();
    },
    // onSuccess: () => {
    //   showToast.success('Microsoft login successful!');
    // },
    onError: (error) => {
      console.error('Microsoft callback failed:', error);
      showToast.error('Authentication failed. Please try again.');
    },
  });
}
